<template>
	<div id="Main">
		<div class="title">
			<p>企业公告</p>
			<p>Announcement</p>
		</div>
		<div class="content">
			<listbox v-for="(itme,index) in listdata" :key="index" :data="itme" @To="To"></listbox>
		</div>
		<div class="more" v-if="more">
			<van-button class="button" @click='getdata(1)' type="default">更多</van-button>
		</div>
		<div class="pages" v-if="!more && listdata.length>0">
			<van-pagination class="pagebox" v-model="currentPage" @change='change' :total-items="count" :show-page-size="3" force-ellipses />
		</div>
		<footerbox></footerbox>
	</div>
</template>
<script>
	import footerbox from '../../components/footer';
	import listbox from '../../components/list';
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {
			footerbox,
			listbox
		},
		data() {
			return {
				listdata: [],
				currentPage: 1,
				more:true,
				count:0,
				pagesize:0
			}
		},
		methods: {
			change(e){
				window.console.log(e)
				this.currentPage=e;
				this.getdata();
			},
			getdata(type) {
				type==1?this.more=false:'';
				axiosPost.getgetlist({
					channel_id: 13,
					page:this.currentPage,
				}).then((res) => {

					if (res.data.code == 1) {
						this.listdata = res.data.data.listData
						this.count = res.data.data.count
						this.pagesize = res.data.data.pagesize
						if (this.listdata[0].image_url && this.listdata[0].image_url.length > 0) {
							this.listdata[0].type = true; /* 公告第一个展示图片(有图片的情况下) */
						}
					} else {
						this.$toast({duration:4000,message:res.data.msg});
					}
				}).catch(() => {

				})
			},
			To(item) {
				let id = item.id
				this.$router.push({
					path: '/businessdetails',
					query: {
						id: id
					}
				})
			},
		},
		mounted() {
			this.getdata();
		}
	}
</script>

<style lang="scss" scoped>
	.pages{
		padding: 1.3rem;
		.pagebox{
			li::after{
				border-color: red;
			}
		}
	}
	.more {
		text-align: right;
		padding: 1.3rem;
		.button {
			background-color: #d03535;
			color: #fff;
			border-radius: 5px;
		}
	}

	#Main {
		display: flex;
		flex-direction: column;
		min-height: 100vh;

		.title {
			padding: 1.3rem;
			background-color: #f2f3fa;
			text-align: left;
			padding-top: 2.3rem;

			p {
				color: rgba(51, 51, 51, .4);
				font-size: 1.6rem;
			}

			p:first-child {
				font-size: 2rem;
				color: #333333;
			}
		}

		.content {
			flex: 1;
		}
	}
</style>
